var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "message-box"
    }
  }, [(_vm.active) ? _c('form', {
    staticClass: "message-form"
  }, [_c('input', {
    staticClass: "form-control name",
    attrs: {
      "placeholder": "Nombre"
    }
  }), _c('input', {
    staticClass: "form-control email",
    attrs: {
      "placeholder": "email"
    }
  }), _c('input', {
    staticClass: "form-control cellphone",
    attrs: {
      "placeholder": "telefono"
    }
  }), _c('textarea', {
    staticClass: "form-control message",
    attrs: {
      "placeholder": "escribe tu mensaje o duda",
      "rows": "3"
    }
  }), _c('button', {
    staticClass: "btn call-to-action special",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Enviar")])]) : _vm._e(), _c('div', {
    staticClass: "message-caller",
    class: {
      active: _vm.active
    },
    on: {
      "click": _vm.change
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad3d17d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/src/components/MessageBox.vue
// module id = 49
// module chunks = 0